<template>
  <Team_index></Team_index>
  <Team_index_bar></Team_index_bar>
  <router-view/>
  <br>
<Footer></Footer>
</template>

<script>
import Header from '../../components/CN/Header'
import Team_index from "../../components/CN/team/Team_index";
import Team_index_bar from "../../components/CN/team/Team_index_bar"
import Footer from "../../components/CN/Footer";

export default {
  name: 'Team',
  components: {Footer, Team_index_bar, Team_index, Header},

}

</script>
